import React from 'react';

const Footer = () => {
  return (
    <footer className="wrap">
      <span>
        © 2026 Victoria Olumide
      </span>

      <span>
        <a href="tel:+2348020585796">
          +234 802 058 5796
        </a>

        {' · '}

        Bergar, Lagos State
      </span>
    </footer>
  );
};

export default Footer;